import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { Control } from '@effector-form';
import { Tooltip } from '@mui/material';
import i18n from '@shared/config/i18n';
import { $isDetailOpen } from '../../models';
import { ticketsVersionForm } from '../../models/detail-sdui-new-version';
import * as Styled from './styled';

const { t } = i18n;

export const TicketsVersionBlock = () => {
  const [isDetailOpen] = useUnit([$isDetailOpen]);
  const { setValue, values } = useUnit(ticketsVersionForm);

  useEffect(() => {
    const newVersion = localStorage.getItem('ticketsNewVersion') === 'new' ? true : false;
    if (values.newVersion === newVersion) return;

    setValue({ path: 'newVersion', value: newVersion });
  }, []);

  return (
    <>
      <Styled.Container>
        <Tooltip title={t('DisableNewTicketFormatHint')}>
          <div>
            <Control.Switch
              name="newVersion"
              label={t('NewTicketFormat')}
              disabled={isDetailOpen}
              form={ticketsVersionForm}
              labelPlacement="start"
            />
          </div>
        </Tooltip>
      </Styled.Container>
    </>
  );
};
